import mixitup from 'mixitup';

const INPUT_CLASS = 'offer-overview-button__radio';
const BASE_SELECTOR = '.offer-overview-filter--';
const OPTIONS = {
    controls: {
        enable: false,
    },
};

const HEADLINE_CONTAINER = document.querySelector(`${BASE_SELECTOR}headline`);
const TEXT_CONTAINER = document.querySelector(`${BASE_SELECTOR}text`);
const TEASER_CONTAINER = document.querySelector(`${BASE_SELECTOR}teaser`);

const HEADLINE_MIXITUP = HEADLINE_CONTAINER ? mixitup(HEADLINE_CONTAINER, OPTIONS) : null;
const TEXT_MIXITUP = TEXT_CONTAINER ? mixitup(TEXT_CONTAINER, OPTIONS) : null;
const TEASER_MIXITUP = TEASER_CONTAINER ? mixitup(TEASER_CONTAINER, OPTIONS) : null;

const HASH = location.hash.substr(1);

function setFilter(input, animate) {
    const CATEGORY = input.value;
    const IS_DEFAULT_CATEGORY = CATEGORY == 'default';
    const NEW_HASH = IS_DEFAULT_CATEGORY ? '' : `#${CATEGORY}`;

    if (HEADLINE_MIXITUP) {
        HEADLINE_MIXITUP.filter(`.offer-overview__headline--${CATEGORY}`, animate);
    }
    if (TEXT_MIXITUP) {
        TEXT_MIXITUP.filter(`.offer-overview__text--${CATEGORY}`, animate);
    }
    if (TEASER_MIXITUP) {
        TEASER_MIXITUP.filter(IS_DEFAULT_CATEGORY ? 'all' : `.category-${CATEGORY}`, animate);
    }

    history.pushState({}, document.title, location.pathname + NEW_HASH);
}

if (HASH) {
    console.log(HASH);
    const INPUT = document.querySelector(`.${INPUT_CLASS}[value="${HASH}"]`);
    if (INPUT) {
        INPUT.checked = true;
        setFilter(INPUT, false);
    }
}

document.addEventListener('change', (event) => {
    const TARGET = event.target;
    if (TARGET.classList.contains(INPUT_CLASS)) {
        setFilter(TARGET, true);
    }
});
